import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Grid,
  Typography,
  Paper,
  Divider,
  Chip,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@mui/material";
import { getStatusColor } from "../../utils/jsUtils";
import Slide from "@mui/material/Slide";

export const AppoinmentDetailPopUp = ({
  dialogOpen,
  handleClose,
  appointmentDetails,
  convertDate,
}) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
  });

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={dialogOpen}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle>
          <Box display={"flex"} justifyContent="space-between">
            {" "}
            <Typography color="primary" variant="h6">
              Appoinment Details
            </Typography>
            <Chip
              sx={{ color: getStatusColor(appointmentDetails?.status) }}
              label={appointmentDetails?.statusContent}
            ></Chip>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container sx={{ pl: 3, pr: 3, pt: 2, pb: 2 }}>
            <Grid item xs={12}>
              <Paper elevation={0} variant="elevation" sx={{ width: "100%" }}>
                <Box
                  sx={{
                    my: 1,
                    borderRadius: 2,
                  }}
                >
                  <Typography textAlign={"left"} variant="h6" px={3}>
                    Appointment Details
                  </Typography>
                  <Grid container sx={{ px: 3, pt: 1, pb: 1 }}>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>Appointment Id</Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {appointmentDetails?.appointmentId}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>Appointment Date</Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {convertDate(appointmentDetails?.appointmentDate) ??
                            "-"}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>Start Time </Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {appointmentDetails?.appointmentStartTime}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>GSTIN </Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {appointmentDetails?.gstIn}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>FC Name</Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {appointmentDetails?.fcName}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>FC Code</Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {appointmentDetails?.fcCode}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>Dock</Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {appointmentDetails?.dockName}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>Count Of Vehicle</Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {appointmentDetails?.countOfVehicle}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={12} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>Remark</Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {" "}
                          {appointmentDetails?.remark}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Divider />

                {appointmentDetails?.poParams &&
                  appointmentDetails?.poParams?.length > 0 && (
                    <span>
                      {" "}
                      <Divider />
                      <Box
                        sx={{
                          my: 1,
                          borderRadius: 2,
                        }}
                      >
                        <Typography
                          textAlign={"left"}
                          variant="h6"
                          px={3}
                          mt={1}
                        >
                          PO Details
                        </Typography>

                        <Grid container sx={{ px: 3, pt: 1, pb: 1 }}>
                          <TableContainer component={Paper}>
                            <Table
                              sx={{ minWidth: 650 }}
                              aria-label="simple table"
                            >
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#dfe3e9" }}>
                                  <TableCell>
                                    <Typography fontWeight={500} fontSize={13}>
                                      PO Number
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      No Of Cases
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      Count of SKUs
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      Incoming Material
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              {appointmentDetails?.poParams?.map(
                                (item, index) => {
                                  return (
                                    <TableBody>
                                      <TableCell align="left">
                                        <Typography
                                          style={{
                                            whiteSpace: "pre-line",
                                            color: "#000",
                                          }}
                                        >
                                          {" "}
                                          {item?.poNumber ?? "-"}{" "}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography
                                          style={{
                                            whiteSpace: "pre-line",
                                            color: "#000",
                                          }}
                                        >
                                          {" "}
                                          {item?.noOfCases ?? "-"}{" "}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography
                                          style={{
                                            whiteSpace: "pre-line",
                                            color: "#000",
                                          }}
                                        >
                                          {" "}
                                          {item?.countOfSkus ?? "-"}{" "}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography
                                          style={{
                                            whiteSpace: "pre-line",
                                            color: "#000",
                                          }}
                                        >
                                          {" "}
                                          {item?.materialType ?? "-"}{" "}
                                        </Typography>
                                      </TableCell>
                                    </TableBody>
                                  );
                                }
                              )}
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Box>
                    </span>
                  )}

                {appointmentDetails?.vehicleParams &&
                  appointmentDetails?.vehicleParams?.length > 0 && (
                    <span>
                      {" "}
                      <Divider />
                      <Box
                        sx={{
                          my: 2,
                          borderRadius: 2,
                        }}
                      >
                        <Typography
                          textAlign={"left"}
                          variant="h6"
                          px={3}
                          mt={1}
                        >
                          Vehicle Details
                        </Typography>

                        <Grid container sx={{ px: 3, pt: 1, pb: 1 }}>
                          <TableContainer component={Paper}>
                            <Table
                              sx={{ minWidth: 650 }}
                              aria-label="simple table"
                            >
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#dfe3e9" }}>
                                  <TableCell>
                                    <Typography fontWeight={500} fontSize={13}>
                                      Vehicle Type
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      Vehicle Registration Number
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      Driver Name
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      Driver Contact Number
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              {appointmentDetails?.vehicleParams?.map(
                                (item, index) => {
                                  return (
                                    <TableBody>
                                      <TableCell align="left">
                                        <Typography
                                          style={{
                                            whiteSpace: "pre-line",
                                            color: "#000",
                                          }}
                                        >
                                          {" "}
                                          {item?.vehicleType ?? "-"}{" "}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography
                                          style={{
                                            whiteSpace: "pre-line",
                                            color: "#000",
                                          }}
                                        >
                                          {" "}
                                          {item?.vrn ?? "-"}{" "}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography
                                          style={{
                                            whiteSpace: "pre-line",
                                            color: "#000",
                                          }}
                                        >
                                          {" "}
                                          {item?.driverName ?? "-"}{" "}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography
                                          style={{
                                            whiteSpace: "pre-line",
                                            color: "#000",
                                          }}
                                        >
                                          {" "}
                                          {item?.driverContactNumber ??
                                            "-"}{" "}
                                        </Typography>
                                      </TableCell>
                                    </TableBody>
                                  );
                                }
                              )}
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Box>
                    </span>
                  )}
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button className="button-primary-alt-text" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
